<template>
  <div>
    <div class="logo">
      <i class="iconfont icon-back" @click="goback()"></i>
      <img src="/static/logo-64x64.png">
    </div>

    <div class="content">
      <div v-if="haveData">
        <circle-item
          v-for="item in circleGoods"
          :key="item._id"
          :item="item"
          :token="encodeToken"
          :handle="true"
          @requery="requery"
        ></circle-item>
      </div>
      <div class="circle-empty" v-else>
        <img src="/static/none-add.png" style="width: 100%;" @click="addCircle">
      </div>

      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="isScrollBusy"
        infinite-scroll-distance="30"
      >
        <div align="center" style="margin-top: 10px; padding-bottom: 5px;">
          <cube-loading style="width: 24px;" v-if="isScrollBusy && !isScrollEnd"/>
          <span style="color: #999999; font-size: 0.8rem;" v-else-if="isScrollEnd && haveData">没有更多了</span>
        </div>
      </div>
    </div>

    <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="addCircle">
      <a href="javascript:;">发布信息</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CircleItem from "../common/CircleItem";

export default {
  components: {
    CircleItem
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      circleGoods: [],
      haveData: true,
      isScrollBusy: false,
      isScrollEnd: false,
      pageNo: 0,
      pageCount: 0
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    requery() {
      this.circleGoods = [];
      this.pageNo = 0;
      this.pageCount = 0;
      this.isScrollEnd = false;
      this.haveData = true;
      this.loadMore();
    },
    loadMore() {
      if (this.isScrollEnd || this.isScrollBusy) {
        return;
      }
      this.isScrollBusy = true;
      this.pageNo = this.pageNo + 1;
      let params = {
        pageNo: this.pageNo
      };
      if (this.queryGoodsType && this.queryTypeValue) {
        params.goodsType = this.queryTypeValue;
      } else if (this.queryBizType && this.queryTypeValue) {
        params.bizType = this.queryTypeValue;
      }
      setTimeout(() => {
        axios
          .get("/api/circle/pagingForMy", { params })
          .then(res => {
            this.isScrollBusy = false;
            if (res.data.success) {
              this.pageCount = res.data.data.pageCount;
              if (this.pageCount > 0) {
                this.haveData = true;
              } else {
                this.haveData = false;
              }

              if (res.data.data.pageNumber >= this.pageCount) {
                this.isScrollEnd = true;
              } else {
                this.isScrollEnd = false;
              }

              this.circleGoods = this.circleGoods.concat(res.data.data.results);
            } else {
              weui.topTips("获取圈子列表出错", 1500);
            }
          })
          .catch(err => {
            this.isScrollBusy = false;
            console.log(err);
            weui.topTips("获取圈子列表出错", 1500);
          });
      }, 500);
    },
    addCircle() {
      this.$router.push("/circleType/-1/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.logo {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #fda800;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.logo i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #fda800;
}
.logo img {
  height: 22px;
}
.circle-empty {
  padding: 50px;
}
.content {
  margin-bottom: 50px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #feb70f;
  margin-top: 10px;
  line-height: 50px;
  position: fixed;
  bottom: 0px;
  width: 100%;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/MyCircle.vue